import type { LocaleMessageBundle } from '../../types'

export const supplierMessages: LocaleMessageBundle = {
  vi: {
    'supplier.supplier.title': 'Nhà cung cấp',
    'supplier.debt.title': 'Công nợ nhà cung cấp',
    'supplier.payment.title': 'Thanh toán nhà cung cấp',
    'supplier.model': 'nhà cung cấp',
    'supplier.actions.create': 'Thêm nhà cung cấp',
    'supplier.actions.update': 'Cập nhật nhà cung cấp',
    'supplier.actions.delete': 'Xóa',
    'supplier.quickCreate': 'Thêm nhanh nhà cung cấp',
    'supplier.dialog.createSubtitle': 'Thêm thông tin nhà cung cấp vào hệ thống',
    'supplier.dialog.updateSubtitle': 'Cập nhật thông tin nhà cung cấp trong hệ thống',
    'supplier.deleteConfirm': 'Bạn có chắc muốn xóa nhà cung cấp {name}?',
    'supplier.fields.code': 'Mã NCC',
    'supplier.fields.name': 'Tên nhà cung cấp',
    'supplier.fields.phone': 'Điện thoại',
    'supplier.fields.email': 'Email',
    'supplier.fields.taxCode': 'Mã số thuế',
    'supplier.fields.address': 'Địa chỉ',
    'supplier.fields.contactName': 'Người liên hệ',
    'supplier.fields.status': 'Trạng thái',
    'supplier.fields.debtAmount': 'Còn nợ',
    'supplier.fields.payableAmount': 'Nợ NCC',
    'supplier.fields.receivableAmount': 'NCC nợ',
    'supplier.fields.paymentDate': 'Ngày thanh toán',
    'supplier.fields.amount': 'Số tiền',
    'supplier.fields.paymentMethod': 'Phương thức',
    'supplier.fields.note': 'Ghi chú',
    'supplier.placeholders.code': 'Nhập mã nhà cung cấp',
    'supplier.placeholders.name': 'Nhập tên nhà cung cấp',
    'supplier.placeholders.phone': 'Nhập số điện thoại',
    'supplier.placeholders.email': 'Nhập email',
    'supplier.placeholders.address': 'Nhập địa chỉ',
    'supplier.placeholders.contactName': 'Nhập người liên hệ',
    'supplier.settlement.titlePay': 'Trả nợ nhà cung cấp',
    'supplier.settlement.titleCollect': 'Thu nợ từ nhà cung cấp',
    'supplier.settlement.subtitlePay': 'Tự phân bổ FIFO theo phiếu cũ nhất',
    'supplier.settlement.subtitleCollect': 'Thu tiền nhà cung cấp đang nợ lại',
    'supplier.settlement.summaryPayable': 'Ta đang nợ',
    'supplier.settlement.summaryReceivable': 'NCC đang nợ ta',
    'supplier.settlement.amountExceedsPayable': 'Số tiền vượt quá nợ hiện tại',
    'supplier.settlement.amountExceedsReceivable': 'Số tiền vượt quá số NCC nợ ta',
    'supplier.settlement.autoAllocate': 'Hệ thống tự chia cho các phiếu còn nợ (cũ nhất trước).',
    'supplier.actions.payDebt': 'Trả nợ',
    'supplier.actions.collectDebt': 'Thu nợ',
    'supplier.history.title': 'Lịch sử trả nợ',
    'supplier.history.empty': 'Nhà cung cấp chưa có giao dịch trả nợ nào',
    'supplier.history.loadFailed': 'Không thể tải lịch sử trả nợ',
    'supplier.history.code': 'Mã phiếu',
    'supplier.history.receipt': 'Phiếu nhập',
    'supplier.history.direction': 'Loại',
    'supplier.history.directionPay': 'Trả nợ',
    'supplier.history.directionCollect': 'Thu nợ',
    'supplier.history.statusPosted': 'Đã ghi sổ',
    'supplier.history.statusCancelled': 'Đã hủy',
    'supplier.history.totalPaid': 'Tổng đã trả',
    'supplier.history.totalCollected': 'Tổng đã thu',
    'supplier.history.cancelPayment': 'Hủy trả nợ',
    'supplier.history.cancelConfirm': 'Bạn có chắc muốn hủy phiếu {code}? Số tiền sẽ được hoàn vào công nợ nhà cung cấp.',
    'supplier.history.cancelReason': 'Lý do hủy',
    'supplier.history.cancelReasonRequired': 'Vui lòng nhập lý do hủy',
    'supplier.history.cancelSuccess': 'Đã hủy phiếu trả nợ',
    'supplier.errors.saveFailed': 'Không thể lưu dữ liệu nhà cung cấp',
    'supplier.errors.deleteFailed': 'Không thể xóa nhà cung cấp',
    'supplier.errors.settlementFailed': 'Không thể thực hiện giao dịch công nợ',
  },
  en: {
    'supplier.supplier.title': 'Suppliers',
    'supplier.debt.title': 'Supplier debt',
    'supplier.payment.title': 'Supplier payments',
    'supplier.model': 'supplier',
    'supplier.actions.create': 'Create supplier',
    'supplier.actions.update': 'Update supplier',
    'supplier.actions.delete': 'Delete',
    'supplier.quickCreate': 'Quick create supplier',
    'supplier.dialog.createSubtitle': 'Add supplier information to the system',
    'supplier.dialog.updateSubtitle': 'Update supplier information in the system',
    'supplier.deleteConfirm': 'Are you sure you want to delete supplier {name}?',
    'supplier.fields.code': 'Supplier code',
    'supplier.fields.name': 'Supplier',
    'supplier.fields.phone': 'Phone',
    'supplier.fields.email': 'Email',
    'supplier.fields.taxCode': 'Tax code',
    'supplier.fields.address': 'Address',
    'supplier.fields.contactName': 'Contact name',
    'supplier.fields.status': 'Status',
    'supplier.fields.debtAmount': 'Debt',
    'supplier.fields.payableAmount': 'We owe',
    'supplier.fields.receivableAmount': 'Supplier owes',
    'supplier.fields.paymentDate': 'Payment date',
    'supplier.fields.amount': 'Amount',
    'supplier.fields.paymentMethod': 'Payment method',
    'supplier.fields.note': 'Note',
    'supplier.placeholders.code': 'Enter supplier code',
    'supplier.placeholders.name': 'Enter supplier name',
    'supplier.placeholders.phone': 'Enter phone number',
    'supplier.placeholders.email': 'Enter email',
    'supplier.placeholders.address': 'Enter address',
    'supplier.placeholders.contactName': 'Enter contact name',
    'supplier.settlement.titlePay': 'Pay supplier debt',
    'supplier.settlement.titleCollect': 'Collect from supplier',
    'supplier.settlement.subtitlePay': 'Auto-allocated FIFO, oldest receipt first',
    'supplier.settlement.subtitleCollect': 'Collect money the supplier owes us',
    'supplier.settlement.summaryPayable': 'We owe',
    'supplier.settlement.summaryReceivable': 'Supplier owes us',
    'supplier.settlement.amountExceedsPayable': 'Amount exceeds current debt',
    'supplier.settlement.amountExceedsReceivable': 'Amount exceeds what the supplier owes',
    'supplier.settlement.autoAllocate':
      'Auto-distributed across receipts still owing (oldest first).',
    'supplier.actions.payDebt': 'Pay debt',
    'supplier.actions.collectDebt': 'Collect',
    'supplier.history.title': 'Debt payment history',
    'supplier.history.empty': 'This supplier has no debt transactions yet',
    'supplier.history.loadFailed': 'Could not load the debt payment history',
    'supplier.history.code': 'Payment code',
    'supplier.history.receipt': 'Purchase receipt',
    'supplier.history.direction': 'Type',
    'supplier.history.directionPay': 'Payment',
    'supplier.history.directionCollect': 'Collection',
    'supplier.history.statusPosted': 'Posted',
    'supplier.history.statusCancelled': 'Cancelled',
    'supplier.history.totalPaid': 'Total paid',
    'supplier.history.totalCollected': 'Total collected',
    'supplier.history.cancelPayment': 'Cancel payment',
    'supplier.history.cancelConfirm': 'Are you sure you want to cancel payment {code}? The amount will be returned to the supplier debt.',
    'supplier.history.cancelReason': 'Cancel reason',
    'supplier.history.cancelReasonRequired': 'Please enter the cancel reason',
    'supplier.history.cancelSuccess': 'Supplier payment cancelled',
    'supplier.errors.saveFailed': 'Could not save supplier data',
    'supplier.errors.deleteFailed': 'Could not delete supplier',
    'supplier.errors.settlementFailed': 'Could not process the debt settlement',
  },
}
